import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef, MatTableDataSource } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import {
  BusinessPartnerScheduleAttributes,
  ScheduleTypeEnum,
} from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MaterialPriceListService } from "app/modules/components/master/strategy-list/strategy-price-list.service";
import MaterialPriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity";
import { IPaginationResult } from "app/common/interfaces";
import { getCode } from "app/utils/method";
import { FormPriceListModalComponent } from "./form-price-list-modal/form-price-list-modal.component";

@Component({
  selector: "app-business-partner-price-list",
  templateUrl: "./business-partner-price-list-modal.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatIconModule,
    FormsModule,
    NgxMatSelectSearchModule,
  ],
})
export class BusinessPartnerPriceListComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  getCode = getCode
  displayedColumns: string[] = [
    "unit",
    "material",
    "price",
    //"scalePrices",
    "action",
  ];

  dataSource = new MatTableDataSource<any>([]);//MaterialPriceListAttributes

  constructor(
    private materialPriceListService: MaterialPriceListService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: BusinessPartnerAttributes
  ) {}

  ngOnInit(): void {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const searchText = filter.toLowerCase();
      
      const searchInText = (text: any): boolean => {
        return text?.toString().toLowerCase().includes(searchText) || false;
      };
      
      return searchInText(data.unit?.code) ||
            searchInText(data.unit?.name) ||
            searchInText(this.getCode(data.material)) ||
            searchInText(data.material?.name) ||
            searchInText(data.price)
    };

    this.findPriceListBP();
  }

  findPriceListBP() {
    this.materialPriceListService.getPriceListByBP(String(this.data._id))
      .subscribe((res) => {
        this.dataSource.data = res.data;
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort;
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openModal(materialPriceList: MaterialPriceListAttributes | null): void {
    const dialogRef = this.dialog.open(FormPriceListModalComponent, {
      panelClass: ".form-modal",
      data: {
        businessPartner: {
          _id: this.data._id,
          id: this.data.id,
          externalKeys: this.data.externalKeys,
          name: this.data.name
        },
        materialPriceList
      },
      width: "850px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {}
    });
  }
}
